/**
 * サイドナビゲーションとパンクズリストで共有するラベル定義。
 * ここを唯一の真実とし、`NAV_BY_ROLE`（components/layout/nav-items.tsx）と各ルートの
 * `staticData.crumb` の両方から参照する。
 */
export const STATIC_LABELS = {
  enterpriseRoot: "ダッシュボード",
  enterpriseActive: "案件管理",
  enterpriseApplications: "応募管理",
  enterpriseNew: "新規案件登録",
  // `enterpriseEdit` / `memberApply` は leaf ルートの crumb ラベル。
  // AutoBreadcrumb は末尾 crumb を「現在地」として灰色テキストで表示するので、これらは
  // 「案件タイトル › 編集」「案件タイトル › 応募」の末尾（現在地）として表示される。
  enterpriseEdit: "編集",
  memberRoot: "案件一覧",
  memberCompanies: "企業一覧",
  memberMyApplications: "マイ応募",
  memberSaved: "保存済み",
  memberApply: "応募",
  adminRoot: "ダッシュボード",
  adminCases: "全案件管理",
  adminApplications: "応募管理",
  adminInquiries: "お問い合わせ管理",
  adminOrganizations: "組織一覧",
  adminUsage: "利用状況",
  adminEnterpriseRegister: "企業登録",
  adminMemberRegister: "会員登録",
  adminAdminRegister: "事務局登録",
  adminKakekomi: "駆け込み寺予約",
  profile: "登録情報",
  // 企業・会員で共通の画面（検証機予約）。表記を揃えるため 1 キーを両ロールで使う。
  pocEnvironment: "検証機予約",
} as const;

/**
 * パンくずを **表示しない** L1 ページのパス集合。
 *
 * AutoBreadcrumb はこの集合に含まれる pathname では何も描画しない。
 * 該当ページはサイドナビ上のエントリ（active 表示）が「ここはどこか」を担うため、
 * breadcrumb を出すと PageHeader と二重表示になる。
 *
 * - `NAV_BY_ROLE` (`components/layout/nav-items.tsx`) の全 `to` を含む
 * - `/admin/organizations/members` はサイドナビにはないが /companies のタブ兄弟なので含める
 *
 * 注意: この集合と NAV_BY_ROLE の同期は `__tests__/route-crumbs.test.ts` で検証している。
 */
export const L1_PATHS: ReadonlySet<string> = new Set([
  // ENTERPRISE
  "/enterprise",
  "/enterprise/active",
  "/enterprise/applications",
  "/enterprise/new",
  "/enterprise/poc-environment",
  // MEMBER
  "/member",
  "/member/companies",
  "/member/my-applications",
  "/member/saved",
  "/member/poc-environment",
  // ADMIN
  "/admin",
  "/admin/cases",
  "/admin/applications",
  "/admin/inquiries",
  "/admin/organizations/companies",
  "/admin/organizations/members",
  "/admin/usage",
  "/admin/enterprise-register",
  "/admin/member-register",
  "/admin/admin-register",
  "/admin/kakekomi",
]);
